<highcharts-chart
  [Highcharts]="this.hc"
  [options]="pieChart"
  style="width: 100%; height: 99%; display: block; overflow: hidden"
>
</highcharts-chart>
